/**
 * Created by xiaoconghu on 2018/12/13.
 */
import {Injectable} from '@angular/core';
import {TableConfig} from '../../entity/tableConfig';
import {FilterCondition} from '../../entity/queryCondition';

@Injectable()
export class TableService {
  /**
   * 表格统一提示配置
   * param handleOK
   * param handleCancel
   * returns {{nzTitle: string; nzContent: string; nzOkText: string; nzOkType:
    * string; nzMaskClosable: boolean; nzOnOk: any; nzCancelText: string; nzOnCancel: any}}
   */
  public tablePrompt(handleOK, handleCancel) {
    const obj = {
      nzTitle: '提示',
      nzContent: '<span>是否确认删除？</span>',
      nzOkText: '确认',
      nzOkType: 'danger',
      nzMaskClosable: false,
      nzOnOk: handleOK,
      nzCancelText: '取消',
      nzOnCancel: handleCancel
    };
    return obj;
  }

  /**
   * 初始化过滤字段
   * param {TableConfig} tableConfig
   * returns {Map<string, FilterCondition>}
   */
  initFilterParams(tableConfig: TableConfig): Map<string, FilterCondition> {
    const queryTerm = new Map();
    if (tableConfig && tableConfig.columnConfig) {
      tableConfig.columnConfig.forEach(item => {
        if (item.searchable && item.key) {
          const filterCondition = new FilterCondition(item.searchKey || item.key);
          filterCondition.filterType = item.searchConfig.type;
          if (item.searchConfig.initialValue) {
            filterCondition.filterValue = item.searchConfig.initialValue;
            filterCondition.initialValue = item.searchConfig.initialValue;
          }
          if (item.searchConfig.type === 'input') {
            // like改成contains，后台要求
            filterCondition.operator = 'contains';
          } else if (item.searchConfig.selectType === 'multiple') {
            // in改成eq，后台要求
            filterCondition.operator = 'eq';
          } else {
            filterCondition.operator = 'eq';
          }
          queryTerm.set(item.key, filterCondition);
        }
      });
    }
    return queryTerm;
  }

  /**
   * 创建数组过滤条件
   * param {Map<string, FilterCondition>} queryTerm
   * returns {FilterCondition[]}
   */
  createFilterConditions(queryTerm: Map<string, FilterCondition>): FilterCondition[] {
    const filterConditions = [];
    queryTerm.forEach(value => {
      // 当filterType时间段的并且返回值存在
      if (value.filterType === 'dateRang' && value.filterValue instanceof Array && value.filterValue.length > 0) {
        const temp = value.filterValue;
        const {filterField, operator} = value;
        const start = {filterValue: 0, filterField, operator}, end = {filterValue: 0, filterField, operator};
        // 去除随机的毫秒值补000
        start.filterValue = Math.floor(temp[0] / 1000) * 1000;
        start.operator = 'gte';
        start['extra'] = 'LT_AND_GT';
        start.filterField = filterField;
        // 去除随机的毫秒值补999
        end.filterValue = Math.floor(temp[1] / 1000) * 1000 + 999;
        end.operator = 'lte';
        end['extra'] = 'LT_AND_GT';
        end.filterField = filterField;
        // 当两个值都有的情况下加入到查询条件里面
        if (start.filterValue && end.filterValue) {
          filterConditions.push(start, end);
        }
      } else {
        const {filterValue, filterField, operator} = value;
        // 当操作符为‘in’并且有值的情况
        if (operator === 'in') {
          if (filterValue && filterValue.length > 0) {
            filterConditions.push({filterValue, filterField, operator});
          }
        } else {
          // filterValue === 0 解决number数量为0的情况
          if (filterValue || filterValue === 0) {
            // 如果是operator为like出去首尾空格
            if (operator === 'contains') {
              const __filterValue = filterValue.trim();
              filterConditions.push({filterValue: __filterValue, filterField, operator});
            } else {
              filterConditions.push({filterValue, filterField, operator});
            }
          }
        }
      }
    });
    return filterConditions;
  }

  /**
   * 清空所有条件
   * param {Map<string, FilterCondition>} queryTerm
   */
  resetFilterConditions(queryTerm: Map<string, FilterCondition>) {
    queryTerm.forEach((value, key) => {
      if (value.initialValue && value.initialValue !== 0) {
        value.filterValue = value.initialValue;
      } else {
        value.filterValue = null;
      }
    });
  }

  /**
   * 创建一个map对象过滤条件
   * param {Map<string, FilterCondition>} queryTerm
   * returns {Map<string, any>}
   */
  createFilterConditionMap(queryTerm: Map<string, FilterCondition>): Object {
    const query = Object.create(null);
    queryTerm.forEach((value, key) => {
      // 如果是operator为like出去首尾空格
      if (value.operator === 'contains' && value.filterValue) {
        query[value.filterField] = value.filterValue.trim();
      } else {
        query[value.filterField] = value.filterValue;
      }
    });
    return query;
  }

  /**
   * 判断所有子元素是否都没有选中
   * param data
   * param expendDataKey 子元素数组名字 string
   */
  checkStatus(data, expendDataKey) {
    // 全不选
    let allUnChecked = true;
    (function checkAllData(_data) {
      for (let i = 0; i < _data.length; i++) {
        if (_data[i].checked) {
          allUnChecked = false;
          break;
        }
        if (_data[i][expendDataKey] && _data[i][expendDataKey].length > 0) {
          checkAllData(_data[i][expendDataKey]);
        }
      }
    })(data);
    return allUnChecked;
  }
}
